import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { EditVehicleQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { DocumentIcon, PencilIcon, PhotoIcon } from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from './edit_form'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { EditAttachments } from './edit_attachments'
import { EditImages } from './edit_images'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={id} />, icon: PencilIcon },
    { name: 'Images', component: <EditImages id={id} />, icon: PhotoIcon },
    { name: 'Attachments', component: <EditAttachments id={id} />, icon: DocumentIcon },
  ]

  const { data, loading } = useQuery<EditVehicleQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle><div>{ loading || !data ? <Loading /> : data.vehicles.nodes[0].name }</div></DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
